import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { css } from 'styled-components';
import { token } from '@atlaskit/tokens';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { Props } from './types';

const ActorItemSkeleton = (props: Props) => {
	if (props.rows > 0) {
		return (
			<TableWrapper data-pollinator-people-table>
				<Table>
					<tbody data-testid="users-and-roles.ui.actors-table.skeleton">
						{Array.from({ length: props.rows }).map((_, index: number) => (
							<TableRow key={`skeleton-${index}`}>
								<LongTableCell>
									<DisplayWrapper>
										<AvatarImage />
										<NameWrapper>
											<Skeleton height="32px" />
										</NameWrapper>
									</DisplayWrapper>
								</LongTableCell>
								<LongTableCell>
									<Skeleton height="32px" />
								</LongTableCell>
								<MediumTableCell>
									<Skeleton height="32px" />
								</MediumTableCell>
								<ShortTableCell>
									<Skeleton height="32px" />
								</ShortTableCell>
							</TableRow>
						))}
					</tbody>
				</Table>
			</TableWrapper>
		);
	}
	return null;
};
ActorItemSkeleton.displayName = 'ActorItemSkeleton';
export default ActorItemSkeleton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Table = styled2.table({
	borderCollapse: 'collapse',
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginBottom: '10px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TableWrapper = styled.div<{
	['data-pollinator-people-table']?: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	table: {
		tableLayout: 'fixed',
	},
});

const tableCellMixin = css({
	border: 'none',
	padding: `${token('space.050', '4px')} ${token('space.100', '8px')}`,
	textAlign: 'left',
});

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LongTableCell = styled.td`
	${tableCellMixin}
	width: 35%;
`;

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MediumTableCell = styled.td`
	${tableCellMixin}
	width: 20%;
`;

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ShortTableCell = styled.td`
	${tableCellMixin}
	width: 10%;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TableRow = styled2.tr({
	padding: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisplayWrapper = styled2.div({
	display: 'flex',
	flexDirection: 'row',
	margin: `${token('space.100', '8px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const NameWrapper = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `calc(100% - ${gridSize * 4}px)`,
	marginLeft: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarImage = styled(Skeleton)({
	borderRadius: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 4}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 4}px`,
	margin: '0 auto',
});
